/* ============================================================
   STENS — Hero slider
   Auto-advance every 6s, manual prev/next + dot navigation
   Pauses on hover, resumes when mouse leaves
   ============================================================ */
(function() {
  'use strict';

  const slider = document.getElementById('heroSlider');
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll('.hero-slide'));
  const dots = Array.from(document.querySelectorAll('#heroSliderDots .hero-dot'));
  const navBtns = Array.from(document.querySelectorAll('.hero-nav-btn'));
  const currentEl = document.getElementById('heroSlideCurrent');
  const totalEl = document.getElementById('heroSlideTotal');

  if (!slides.length) return;

  const total = slides.length;
  let current = 0;
  let timer = null;
  const INTERVAL = 6000;

  function pad2(n) { return n < 10 ? '0' + n : '' + n; }

  function go(to) {
    if (to === current) return;
    to = ((to % total) + total) % total;
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = to;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
    if (currentEl) currentEl.textContent = pad2(current + 1);
  }

  function next() { go(current + 1); }
  function prev() { go(current - 1); }

  function startTimer() {
    stopTimer();
    timer = setInterval(next, INTERVAL);
  }
  function stopTimer() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  // Manual nav buttons
  navBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.nav === 'next') next();
      else prev();
      // Reset timer so user gets fresh interval after manual change
      startTimer();
    });
  });

  // Dot navigation
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const i = parseInt(dot.dataset.slide, 10);
      if (!isNaN(i)) {
        go(i);
        startTimer();
      }
    });
  });

  // Pause on hover, resume when mouse leaves
  const heroEl = slider.closest('.hero');
  if (heroEl) {
    heroEl.addEventListener('mouseenter', stopTimer);
    heroEl.addEventListener('mouseleave', startTimer);
  }

  // Pause when tab is hidden, resume when visible
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopTimer();
    else startTimer();
  });

  // Set total
  if (totalEl) totalEl.textContent = pad2(total);
  if (currentEl) currentEl.textContent = pad2(1);

  startTimer();
})();
